import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ThemeOptions } from "store/view/types";
import { RootState } from "store/reducers";

export function useTheme() {
    const { theme: themeFromState } = useSelector(
        (state: RootState) => state.view
    );

    const getDeviceTheme = () => {
        return window.matchMedia("(prefers-color-scheme: dark)").matches
            ? ThemeOptions.Dark
            : ThemeOptions.Light;
    };

    const theme = useMemo(() => {
        switch (themeFromState) {
            case ThemeOptions.Light:
                return ThemeOptions.Light;
            case ThemeOptions.Dark:
                return ThemeOptions.Dark;
            case ThemeOptions.Device:
            default:
                return getDeviceTheme();
        }
    }, [themeFromState]);

    return { theme };
}
